export default class EQAdditionalInfoTypes {
  static JSON_SOURCE = 1
  static HTML_COMPLETE = 2
  static HTML_PARTIAL = 3
}
